import { render, staticRenderFns } from "./worms.vue?vue&type=template&id=792fd533"
import script from "./worms.vue?vue&type=script&lang=js"
export * from "./worms.vue?vue&type=script&lang=js"
import style0 from "./worms.vue?vue&type=style&index=0&id=792fd533&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports